import type { CSSProperties } from 'react';
import type { Theme } from '@floorpoll/shared';

/**
 * Turns a quiz theme into CSS custom properties.
 *
 * Public views read `--quiz-*` throughout, so branding is a data change rather
 * than a code change.
 */
export function themeStyle(theme: Theme | undefined): CSSProperties {
  if (!theme) return {};

  const style: Record<string, string> = {
    '--quiz-primary': theme.primaryColor,
    '--quiz-accent': theme.accentColor,
    '--quiz-bg': theme.backgroundColor,
    '--quiz-text': theme.textColor,
  };

  if (theme.backgroundImageUrl) {
    // The scrim keeps text legible over an arbitrary uploaded photo.
    style['--quiz-bg-image'] =
      `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url("${theme.backgroundImageUrl}")`;
  }

  return style as CSSProperties;
}
